import type { ViewerContext } from '../../context/AuthContext'
import type { Visit } from './visits'
import type { CorrectiveAction } from './correctiveActions'

type ViewerRole = ViewerContext['role']

/**
 * Filter rows to viewer facility scope.
 * #1897: empty facilityIds fail closed (return []) — empty is no longer "show all / corporate".
 * Callers that intend tenant-wide scope must pass the concrete facility id list after hydrate.
 */
export function applyFacilityScope<T extends { facility_id: string | null }>(rows: T[], facilityIds: string[]): T[] {
  if (!facilityIds || facilityIds.length === 0) return []
  const scope = new Set(facilityIds)
  return rows.filter((row) => row.facility_id && scope.has(row.facility_id))
}

export function canExecuteChecklist(role: ViewerRole, visitStatus: Visit['status']): boolean {
  if (role === 'Reviewer') return false
  if (visitStatus === 'released' || visitStatus === 'archived') return false
  return true
}

export function visitStatusBadgeClass(status: Visit['status']): string {
  if (status === 'in_progress') return 'badge-in-progress'
  if (status === 'released') return 'badge-released'
  if (status === 'archived') return 'badge-archived'
  return 'badge-scheduled'
}

export function buildSelfMonitoringSummary(
  visits: Visit[],
  actions: CorrectiveAction[],
): {
  overdue_actions: number
  active_visits: number
  released_visits: number
} {
  const overdue_actions = actions.filter((action) => action.status === 'overdue').length
  const active_visits = visits.filter((visit) => visit.status === 'in_progress' || visit.status === 'scheduled').length
  const released_visits = visits.filter((visit) => visit.status === 'released').length

  return {
    overdue_actions,
    active_visits,
    released_visits,
  }
}
